// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { KeycloakConfig } from "keycloak-angular";

const keycloakConfig: KeycloakConfig = {
  //url: 'http://portaldelempleadoopsolutions.es:8080/auth',
  url: 'https://portaldelempleadoopsolutions.es/auth',
  realm: 'Ops',
  clientId: 'front-ops'
};





export const environment = {
  production: true,
  BASE_URL: "https://portaldelempleadoopsolutions.es",
  API_PREFIX: "/portalempleado",
  PORTS: {
    BASE: 8899,
    PROYECTOS: 1111,
    APLICACIONES: 2222,
    RELEASES: 3333,
    FEATURES: 4444,
  },
  translateUrl: '/assets/i18n/',
  baseDomain: "portaldelempleadoopsolutions.es/ops/api",
  baseUrl: 'https://portaldelempleadoopsolutions.es/ops/api',
  baseScreenUrl: 'https://portaldelempleadoopsolutions.es/ops/api/pantallas',
  baseGatewayUrl: 'https://portaldelempleadoopsolutions.es/ops/api',
  keycloakConfig: keycloakConfig,
  showMockButtons: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

